<template>
  <el-container style="position: relative;">
    <el-main  style="padding: 10px;">
      <div class="system-main">
        <div class="system-body" v-for="(item, index) in systemData" :key="index">
          <h2>{{ item.type }}</h2>
          <el-row  class="system-row">
            <el-col :span="3" v-for="(t,i) in item.child" :key="i" style="margin: 8px 0;">
              <div class="cursor_point" style=" border: 1px solid #e6e8eb;width: 100px; height: 100px;border-radius: 13px;display: flex;align-items: center;justify-content: center;margin:0 auto">
                <div>
                  <div style="display: flex;justify-content: center;" @click="goSys(t)" >
                    <div>
                      <img class="system-icon" :src="global.BASE_URL + t.systemIcon" fit="cover"></img>
                      <!-- <i class="system-icon el-icon-monitor" :style="{'background-color':color(t.systemName)}"></i> -->
                    </div>
                  </div>
                  <div class="system-name" @click="goSys(t)">{{ t.systemName }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="system-main" style="margin-top: 10px;">
        <div class="system-body">
          <h2>常用功能</h2>
          <!-- <div class="app-list">
            <el-col :span="3" :style="{'margin-right':'28.2px'}" class="app-list_item cursor_point" v-for="(item,index) in appData" :key="index">
              <i :class="item.iconsUrl" @click="goApp(item)" :style="{'color':color(item.menuName),'height':'50px','width':'50px','font-size':'50px'}"></i>
              <div @click="goApp(item)" style="font-size: 14px;">{{ item.menuName }}</div>
            </el-col>
          </div> -->
          <el-row class="system-row">
            <el-col :span="3" v-for="(t,i) in appData" :key="i" style="margin: 8px 0;">
              <div style="width: 100px; height: 100px;border-radius: 13px;display: flex;align-items: center;justify-content: center;margin:0 auto">
                <div>
                  <div style="display: flex;justify-content: center;" @click="goApp(t)" >
                    <svg v-if="t.picUrl&&t.picUrl.startsWith('#hs-icon')"  class="hs-icon" style="font-size:50px;margin-top: 12px;" aria-hidden="true">
                      <use :xlink:href="t.picUrl"></use>
                    </svg>
                    <div v-else class="icon-app cursor_point" :style="{'--background-color':t.background,'--shadow-color':t.shadow}">
                      <i v-if="t.iconsUrl && t.iconsUrl !== 'el-icon-more'" :class="t.iconsUrl" @click="goApp(t)" :style="{'height':'50px','width':'50px','font-size':'26px'}"></i>
                      <i v-else-if="t.iconsUrl == 'el-icon-more'" :class="t.iconsUrl" @click="goApp(t)" :style="{'background-color':'#f0f2f5','height':'50px','width':'50px','font-size':'26px','color':'#83898f'}"></i>
                      <i v-else class="el-icon-document" :class="t.iconsUrl" @click="goApp(t)" :style="{'--background-color':t.background,'--shadow-color':t.shadow,'height':'50px','width':'50px','font-size':'26px'}"></i>
                      <!-- <i class="system-icon el-icon-monitor" :style="{'background-color':color(t.systemName)}"></i> -->
                    </div>
                  </div>
                  <div class="system-name" style="margin-top: 10px;" @click="goApp(t)">{{ t.menuName }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- <div class="footCss"></div> -->
    </el-main>
  </el-container>
</template>

<script>
import Cookies from 'js-cookie'
import { getUserColor } from '@/assets/common/common.js'
import { redirectEncrypt } from '../../assets/common/redirectEncrypt';
export default {
  name: "systemList",
  data() {
    return {
      getUserColor,
      systemData: [
        {
          type: '系统服务',
          child: [
            {
              name: 'ERP'
            },
            {
              name: 'OA'
            },
            {
              name: '流向系统'
            },
            {
              name: 'EHR'
            },
            {
              name: '费用管控系统'
            },
            {
              name: '大数据管理平台'
            },
            {
              name: '访客预约管理'
            },
            {
              name: '车辆应用'
            },
            {
              name: '食堂管理系统'
            },
            {
              name: '汉森学堂'
            },
            {
              name: '提案系统'
            }
          ]
        },
      ],
      openSystem:[],
      appData:[
        {
          name:'会议预定',
          srcUrl:require('@/assets/images/meetting.png')
        },
        {
          name:'工作汇报',
          srcUrl:require('@/assets/images/working.png')
        },
        {
          name:'通讯录',
          srcUrl:require('@/assets/images/person.png')
        },
        {
          name:'知识库',
          srcUrl:require('@/assets/images/knowledge.png')
        },
        {
          name:'学术会议',
          srcUrl:require('@/assets/images/meet.png')
        },
        {
          name:'工资条',
          srcUrl:require('@/assets/images/wages.png')
        },
        {
          name:'研发知识档案管理',
          srcUrl:require('@/assets/images/archvages.png')
        },
        {
          name:'团队排班',
          srcUrl:require('@/assets/images/schedule.png')
        },
        {
          name:'知识产权年度规划',
          srcUrl:require('@/assets/images/year.png')
        },
        {
          name:'基础科研年度规划',
          srcUrl:require('@/assets/images/keyan.png')
        },
        {
          name:'政策项目申报',
          srcUrl:require('@/assets/images/project.png')
        },
        {
          name:'行政合同管理',
          srcUrl:require('@/assets/images/hetong.png')
        },
        {
          name:'办公用品借用',
          srcUrl:require('@/assets/images/yongpin.png')
        },
        {
          name:'福利申请',
          srcUrl:require('@/assets/images/fuli.png')
        }
      ]
    }
  },
  methods: {
    returnColor(){
      let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
      let colorList2 = ['rgba(12, 192, 201,.3)', 'rgba(255, 171, 36,.3)', 'rgba(46, 156, 255,.3)', 'rgba(255, 105, 82,.3)']
      const randomIndex = Math.floor(Math.random() * colorList.length)
      console.log(colorList[randomIndex],'colorList[randomIndex]')
      return {background:colorList[randomIndex],shadow:colorList2[randomIndex]}
    },
    HandleClose(){
      console.log('handoleColos')
    },
    async goSys(t){
      let flag = await this.verifyToken()
      if(flag){
        console.log('gosys')
        if(t.systemType === 'internal'){
          if(t.systemId === 1){
            console.log(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem')
            let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem')
            console.log('完整路径',url)
            window.open(url,'_blank');
            // if(this.openSystem.findIndex(item => item.id === t.systemId) === -1){
            //   let openItem =  window.open(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem','_blank');
            //   openItem.addEventListener('unload',this.HandleClose)
            //   this.openSystem.push({id:t.systemId, item: openItem})
            // }else{
            //   console.log(this.openSystem.find(item => item.id === t.systemId),'this.openSystem.find(item => item.id === t.systemId)')
            //   this.openSystem.find(item => item.id === t.systemId).item.focus()
            // }
          }else{
            console.log(t.systemUrl+'?ticket='+Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode='+t.systemCode+'&token=' + Cookies.get(`token_${window.location.port}`))
            let url = await redirectEncrypt(t.systemUrl+'?ticket='+Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode='+t.systemCode+'&token=' + Cookies.get(`token_${window.location.port}`))
            console.log('完整路径',url)
            window.open(url,'_blank');
          }
        }else if(t.systemType === 'external'){
          if(t.systemId === 121 || t.systemId === 1153){
            window.open(t.systemUrl,'_blank');
          }else{
            this.$axios.post(this.global.BASE_URL_2971 + t.systemUrl,{}).then(res=>{
              if(res.data.status === 'Y'){
                console.log(res.data.data)
                if(t.systemId === 104){
                  window.open('http://10.0.0.181:8089/api/sso?token='+res.data.data,'_blank');
                }else if(t.systemId === 106){
                  console.log(res.data.data,'ddd')
                  window.open(res.data.data,'_blank');
                }
              }
            })
          }
        }
      }
    },
    async verifyToken(){
      let res = await this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/system/findMySystem",{
        data: {
        },
        pageIndex: 0,
        pageSize: 99,
      })
      console.log(res,'res')
      if(res.data.status === 'Y'){
        console.log('-------token没问题---------')
        return true
      }else{
        return false
      }
    },
    goApp(t){
      console.log(t,'t')
      if(!t.menuCode){
        window.open(this.global.BASE_URL_2971+'/#/index?token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+t.systemId+'&systemCode=oaSystem','_blank');
      }else{
        window.open(this.global.BASE_URL_2971+'/#/oaSystem/'+t.menuCode+'?toDo=true','_blank');
      }
    },
    color (name) {
      let num = ''
      //循环人名前两位，把汉字转换成字符的 Unicode 编码，生成10位数字
      for (let i = 0; i < 2; i++) {
        num += parseInt(name[i].charCodeAt(0), 10)
      }
      //经过尝试，使用rgb格式颜色，手动固定R色值，给G和B值随机，最容易控制出想要的色彩
      //取任意两位数字X2,让颜色尽可能拉开差距，并保证不超过255
      return 'rgb(80,' + (num.slice(3, 5) * 2) + ',' + (num.slice(6, 8) * 2) + ')'
    },
    getSystem() {
      this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/system/findMySystem",{
        data: {
        },
        pageIndex: 0,
        pageSize: 99,
      }).then(res=>{
        if(res.data.status === 'Y'){
          this.systemData[0].child = res.data.data
          this.getApp()
        }
      })
    },
    getApp() {
      let user = JSON.parse(localStorage.getItem('user'))
      this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/shortcut/findAllShortcuts",{
        data: {
          userInfoId: user.userInfoId,
          systemId: user.systemId
        },
      }).then(res=>{
        if(res.data.status === 'Y'){
          console.log()
          this.appData = res.data.data.map(item => {
            const  color= this.getUserColor({item,name:item.menuName});
            item.background = color.backgroundColor;
            item.shadow = color.BoxShadowColor;
            return item
          })
          if(this.systemData[0].child.findIndex( t => t.systemId == 1) !== -1){
            // this.appData.push({
            //   iconsUrl:'el-icon-more',
            //   systemId: 1,
            //   menuName: '更多',
            //   background:'#F0F2F5',
            //   shadow:'rgba(240, 242, 245,.3)'
            // })
          }
        }
      })
    },
  },
  created() {
    this.getSystem()
  }
}
</script>

<style lang="less" scoped>
.cursor_point{
  transition: ease .3s;
    img,i{
      transition: ease .3s;
    }
}
.cursor_point:hover {
  box-shadow: 2px 8px 15px 0 rgba(0,0,0,.04);
  img,i{
    transform: scale(1.2);
  }
}
.icon-app{
  background-color:#F0F2F5;
}
.icon-app.cursor_point:hover {
  box-shadow: 2px 8px 15px 0 var(--shadow-color);
  border-radius: 50%;
  
}
.icon-app.cursor_point {
  background-color:var(--background-color);
  border-radius: 50%;
  transition: ease .3s;
}
.system-main {
  margin: 0 auto;
  font-family: PingFang SC, Microsoft Yahei, Avenir, Segoe UI, Hiragino Sans GB, STHeiti, "Microsoft Sans Serif", WenQuanYi Micro Hei, sans-serif;
  display: flex;  
  justify-content: center;
  
  .system-body {
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    width: 1176px;
    min-height: 320px;

    h2 {
      background-size: contain;
      font-size: 18px;
      font-weight: 700;
      height: 40px;
      color: #0e1114;
      margin-top: 0;
      margin-bottom: 0;
    }

    .system-icon {
      width: 30px;
      height: 30px;
      font-size: 26px;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 10px;
    }

    .system-name {
      font-weight: 500;
      color: #0e1114;
      letter-spacing: 0;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      padding: 0 5px;
    }

    .app-list {
      display: flex;
      flex-wrap: wrap;

      .app-list_item {
        width: 126px;
        height: 126px;
        margin-bottom: 28px;
        background: hsla(0,0%,100%,0);
        // border: 1px solid #ebe8eb;
        border: none;
        text-align: center;
        border-radius: 13px;
        display: flex;
        flex-direction: column;
        justify-content: center; /* 垂直居中 */
        align-items: center;    /* 水平居中 */

        div {
          margin-top: 15px;
        }
      }
    }
  }
}

.icon-app i {
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footCss {
    position: absolute;
    bottom: 0;
    width: 1250px;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 106px;
    box-sizing: border-box;
    background: url(../../assets/images/red-footer-background.png) no-repeat;
    background-size: 100% 100%;
  }
  .system-row{
    min-height:116px;
  }
</style>


// WEBPACK FOOTER //
// src/views/main/system-list.vue